import { render, staticRenderFns } from "./ActivityEmotionSpaceSection1.vue?vue&type=template&id=4b7a8784&scoped=true"
import script from "./ActivityEmotionSpaceSection1.vue?vue&type=script&lang=js"
export * from "./ActivityEmotionSpaceSection1.vue?vue&type=script&lang=js"
import style0 from "./ActivityEmotionSpaceSection1.vue?vue&type=style&index=0&id=4b7a8784&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7a8784",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b7a8784')) {
      api.createRecord('4b7a8784', component.options)
    } else {
      api.reload('4b7a8784', component.options)
    }
    module.hot.accept("./ActivityEmotionSpaceSection1.vue?vue&type=template&id=4b7a8784&scoped=true", function () {
      api.rerender('4b7a8784', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/AppPage/ HundredDayOath/compoents/model/ActivityEmotionSpaceSection1.vue"
export default component.exports